import "./App.css";
import { useCallback, useEffect, useState } from "react";
import { Outlet, Link, useNavigate } from "react-router-dom";
import CurrentUser from "./components/CurrentUser";
import { jwtDecode } from "jwt-decode";

function App() {
    const [jwtToken, setJwtToken] = useState("");
    const navigate = useNavigate();
    const [alertClassName, setAlertClassName] = useState("d-none");
    const [alertMessage, setAlertMessage] = useState("");
    const [tickInterval, setTickInterval] = useState();
    const [userRoles, setUserRoles] = useState([]);

    const logOut = () => {
        const requestOptions = {
            method: "GET",
            credentials: "include",
        };
        fetch(
            `${process.env.REACT_APP_BACKEND}/api/token/invalidate`,
            requestOptions
        )
            .catch((error) => {
                console.log("error loggin out", error);
            })
            .finally(() => {
                setJwtToken("");
            });
        navigate("/login");
    };

    const toggleRefresh = useCallback(
        (status) => {
            console.log("click");
            if (status) {
                console.log("turning on ticking");
                let i = setInterval(() => {
                    const requestOptions = {
                        method: "POST",
                        credentials: "include",
                    };
                    fetch(
                        `${process.env.REACT_APP_BACKEND}/api/token/refresh`,
                        requestOptions
                    )
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.token) {
                                setJwtToken(data.token);
                                // Decode the JWT token to get the user role
                                const decodedToken = jwtDecode(data.token);
                                setUserRoles(decodedToken.roles);
                                toggleRefresh(true);
                            }
                        })
                        .catch((error) => {
                            console.log("user is not logged in", error);
                        });
                }, 600000);
                setTickInterval(i);
                console.log("setting tick interval to", i);
            } else {
                console.log("turning off ticking");
                console.log("turning off tick interval", tickInterval);
                setTickInterval(null);
                clearInterval(tickInterval);
            }
        },
        [tickInterval]
    );

    useEffect(() => {
        if (jwtToken === "") {
            const requestOptions = {
                method: "POST",
                credentials: "include",
            };
            fetch(
                `${process.env.REACT_APP_BACKEND}/api/token/refresh`,
                requestOptions
            )
                .then((response) => response.json())
                .then((data) => {
                    if (data.token) {
                        setJwtToken(data.token);
                        // Decode the JWT token to get the user role
                        const decodedToken = jwtDecode(data.token);
                        setUserRoles(decodedToken.roles);
                        toggleRefresh(true);
                    }
                })
                .catch((error) => {
                    console.log("user is not logged in", error);
                });
        }
    }, [jwtToken, toggleRefresh]);

    return (
        <div className="container">
            <div className="row">
                <div className="col">
                    <h1 className="mt-3">100 Лидов</h1>
                </div>
                <div className="col text-end">
                    {jwtToken === "" ? (
                        <Link to="/login">
                            <span className="badge bg-success">Вход</span>
                        </Link>
                    ) : (
                        <>
                            <CurrentUser jwtToken={jwtToken} />

                            <a href="#!" onClick={logOut}>
                                <span className="badge bg-danger">Выход</span>
                            </a>
                        </>
                    )}
                </div>
                <hr className="mb-3"></hr>
            </div>

            <div className="row">
                <div className="col-md-2">
                    <nav>
                        <div className="list-group">
                            <Link
                                to="/"
                                className="list-group-item list-group-item-action"
                            >
                                Home
                            </Link>

                            {jwtToken !== "" && (
                                <Link
                                    to="/leads"
                                    className="list-group-item list-group-item-action"
                                >
                                    Лиды
                                </Link>
                            )}

                            {jwtToken !== "" &&
                                !userRoles.includes("ROLE_ROOT") && (
                                    <Link
                                        to="/campaigns"
                                        className="list-group-item list-group-item-action"
                                    >
                                        Кампании
                                    </Link>
                                )}

                            {jwtToken !== "" &&
                                userRoles.includes("ROLE_ROOT") && (
                                    <Link
                                        to="/campaigns-admin"
                                        className="list-group-item list-group-item-action"
                                    >
                                        Кампании
                                    </Link>
                                )}

                            {jwtToken !== "" && (
                                <Link
                                    to="/sources"
                                    className="list-group-item list-group-item-action"
                                >
                                    Источники лидов
                                </Link>
                            )}
                            {jwtToken !== "" && (
                                <Link
                                    to="/users"
                                    className="list-group-item list-group-item-action"
                                >
                                    Пользователи
                                </Link>
                            )}
                        </div>
                    </nav>
                </div>
                <div className="col-md-10">
                    <Outlet
                        context={{
                            jwtToken,
                            setJwtToken,
                            setAlertClassName,
                            setAlertMessage,
                            navigate,
                            userRoles,
                        }}
                    />
                </div>
            </div>
        </div>
    );
}

export default App;
